import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=bb1d8f7a&"
import script from "./Delegates.vue?vue&type=script&lang=js&"
export * from "./Delegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports